import React, { useEffect, useState, forwardRef, useRef } from "react";
import Style from "./CustomInput.module.css";
import { ReactComponent as EyeOn } from "../../../../assets/svg/EyeOn.svg";
import { ReactComponent as EyeOff } from "../../../../assets/svg/EyeOff.svg";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { NumericFormat } from "react-number-format";
import TimePicker from "rc-time-picker";
import "rc-time-picker/assets/index.css";
import InputMask from "react-input-mask";
import { tFullConverter24 } from "../../../../helpers/utils";
import {
  localDateToISODateString,
  localDateFormatted,
  dateFormats,
} from "../../../../utils/systemSettings";

const CustomInput = forwardRef((props, ref) => {
  const {
    inputwd,
    icon,
    placeholder,
    DateStyleClass,
    type,
    value,
    handleChange,
    cursorPosition,
    handleBlur,
    inputClass,
    iconClass,
    labelClass,
    label,
    errorMessage,
    dir,
    isRequired,
    isDisabled = false,
    max,
    InputIconProp,
    width = null,
    height = null,
    DateStyles = null,
    displayErrorMessage = true,
    onKeyDown,
    loading = false,
    currency = false,
    inline = false,
    minDate = null,
    disabledHours = null,
    disabledMinutes = null,
    maxDate = null,
    onKeyUp = null,
    timeInputClass = null,
    openPicker = false,
    autocomplete="off",
    rightStaticText= null,
    disabelWeekends = false
  } = props;
  const [eyeOn, setEyeOn] = useState(false);
  const [inputType, setInputType] = useState(type);
  const settings = JSON.parse(localStorage.getItem("settings"));
  const [setting] = useState(settings);
  const [inputValue, setInputValue] = useState("");
  const timeInputRef = useRef(null);
  const pickerRef = useRef(null);
  const [isPickerVisible, setPickerVisible] = useState(false);


useEffect(() => {    
  if (openPicker) {
    setPickerVisible(true);
  } }, [openPicker]);

  const handleClickOutside = (event) => {
    if (
      pickerRef.current &&
      timeInputRef.current &&
      event.target.tagName.toLowerCase() != "li" &&
      (event?.target?.className
        ? event.target.className.split(" ")?.[0] !==
            "rc-time-picker-panel-inner" &&
          event.target.className.split(" ")?.[0] !==
            "rc-time-picker-panel-select" &&
          event.target.className.split(" ")?.[0] !== "react-datepicker__day"
        : true)
    ) {
      setPickerVisible(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleTimeValue = (utcTimeString) => {
    if (!utcTimeString) return null;
    const refDate = moment.utc().format("YYYY-MM-DD");
    const utcDateTime = `${refDate} ${utcTimeString}`;
    const timeFormat =
      settings?.regionalSettings?.timeFormat?.toLowerCase() === "hh:mm a"
        ? "hh:mm A"
        : "HH:mm";

    return moment.utc(utcDateTime, timeFormat).local();
  };

  const handleTimeValueMask = (utcTimeString) => {
    if (!utcTimeString) return null;
    const refDate = moment.utc().format("YYYY-MM-DD");
    const utcDateTime = `${refDate} ${utcTimeString}`;
    const timeFormat =
      settings?.regionalSettings?.timeFormat?.toLowerCase() === "hh:mm a"
        ? "hh:mm A"
        : "HH:mm";

    return moment.utc(utcDateTime).local().format(timeFormat);
  };

  const handleTimeChange = (time) => {
    const refDate = moment.utc().format("YYYY-MM-DD");
    const localDateTimeString = `${refDate} ${time}`;
    const localDateTime = moment(localDateTimeString, "YYYY-MM-DD HH:mm");
    const utcMoment = localDateTime.utc();
    handleChange(utcMoment.format("HH:mm"));
  };

  const handleOnChange = (e) => {
    if (label?.toLowerCase() === "status") {
      const res = e.target.value.match(/^[a-zA-Z ]*$/);
      if (e.target.value === "") {
      } else if (!res) {
        return;
      }
    }
    if (type === "number") {
      handleChange && handleChange(e);
    } else if (type === "time") {
      if (e?.target) {
        let newValue = e.target.value;
        if (newValue.match(/^(0[0-9]|1[0-2]):([0-5][0-9]) (AM|PM)$/)) {
          newValue = tFullConverter24(e.target.value);
        }

        handleTimeChange(newValue);
      } else {
        handleTimeChange(e.format("HH:mm"));
      }
    } else {
      handleChange(e.target.value);
    }
    if (type !== "number") {
      cursorPosition && cursorPosition(e.target.selectionStart);
    }
  };

  const handleShow = () => {
    setEyeOn(!eyeOn);
    eyeOn ? setInputType("password") : setInputType("text");
  };

  const getIcon = () => {
    switch (type) {
      case "password":
        return eyeOn ? (
          <EyeOn onClick={handleShow} />
        ) : (
          <EyeOff onClick={handleShow} />
        );
      case "text":
        return icon;
      default:
        return <></>;
    }
  };

  const handleDateChange = (newDate) => {
    handleChange(localDateToISODateString(newDate));
  };

  const handleInputChange = (event) => {
    const input = event.target.value;
    const parsedDate = moment(input, dateFormats, true);

    if (parsedDate.isValid()) {
      setInputValue(parsedDate.toDate());
      handleChange(localDateToISODateString(parsedDate));
    }
  };

  useEffect(() => {
    if (value && type === "date") {
      setInputValue(moment(value).toDate());
    } else {
      setInputValue(value);
    }
  }, [value, type]);

  const handleFocus = () => {
    setPickerVisible(true);
  };

  useEffect(() => {
    if (timeInputRef.current) {
      timeInputRef.current.picker.click();
    }
  }, [isPickerVisible]);

  const isWeekday = (date) => {
    const day = date.getDay();
    return day !== 0 && day !== 6; // 0 = Sunday, 6 = Saturday
  };
  return (
    <>
      <div
        className={`${inputwd} position-relative`}
        style={{ width: width, height: height }}
      >
        {label && (
          <label className={`${labelClass} Input_label`}>
            {label} {isRequired && <span className="Input_staric">*</span>}
          </label>
        )}
        <div className="Input_wrapper position-relative" id="popover">
          {loading ? (
            <Skeleton
              height={40}
              baseColor="#e0e0e0"
              highlightColor="#ECE7FD"
            />
          ) : type === "date" ? (
            <DatePicker
              minDate={moment(minDate).toDate()}
              maxDate={moment(maxDate).toDate()}
              selected={inputValue}
              onChange={handleDateChange}
              disabled={isDisabled}
              filterDate={disabelWeekends && isWeekday}
              dateFormat={setting.regionalSettings.dateFormat}
              className={`DatePickerInput ${
                errorMessage && "Input_errorInput"
              } ${DateStyleClass} ${isDisabled && 'cursor-not-allowed'}`}
              onBlur={handleBlur}
              popperPlacement="bottom-start"
              customInput={
                <input
                  value={localDateFormatted(setting, inputValue)}
                  onChange={handleInputChange}
                  onKeyUp={onKeyUp && onKeyUp}
                  placeholder="Enter date"
                  width="100%"
                  style={DateStyles}
                  ref={ref}
                />
              }
              placeholderText={
                !label && isRequired
                  ? `${setting.regionalSettings.dateFormat} *`
                  : setting.regionalSettings.dateFormat
              }
            />
          ) : type === "number" ? (
            <>
              <NumericFormat
                value={value}
                thousandSeparator={setting.regionalSettings.groupSeparator}
                decimalSeparator={setting.regionalSettings.decimalSeparator}
                prefix={
                  currency
                    ? `${settings.regionalSettings.currency.split(" ")[1]} `
                    : ""
                }
                decimalScale={3}
                onValueChange={(values) => {
                  handleOnChange(values.value);
                }}
                allowNegative={true}
                placeholder={placeholder}
                className={` ${inputClass} Input ${
                  errorMessage && "Input_errorInput"
                }`}
                onBlur={handleBlur}
                disabled={isDisabled}
              />
            </>
          ) : type === "time" ? (
            <div>
              <InputMask
                mask={
                  setting.regionalSettings.timeFormat.toLowerCase() === "hh:mm"
                    ? "99:99"
                    : "99:99 aa"
                }
                style={timeInputClass}
                placeholder={setting.regionalSettings.timeFormat}
                maskChar={null}
                id="time"
                onFocus={handleFocus}
                onChange={handleOnChange}
                // onBlur={() => {
                //   handleBlurTimePicker();
                // }}
                onKeyDown={onKeyDown}
                disabled={isDisabled}
                required={isRequired}
                value={handleTimeValueMask(value)}
              >
                {(inputProps) => (
                  <input
                    className={`${inputClass} Input ${
                      errorMessage && "Input_errorInput"
                    }`}
                    {...inputProps}
                    type="text"
                  />
                )}
              </InputMask>
              {isPickerVisible && (
                <div ref={pickerRef} style={{ height: 0 }}>
                  {" "}
                  {/* Hide TimePicker */}
                  {disabledHours && disabledMinutes ? (
                    <TimePicker
                      value={handleTimeValue(value)}
                      onChange={handleOnChange}
                      showSecond={false}
                      allowEmpty={false}
                      use12Hours={
                        settings?.regionalSettings?.timeFormat === "hh:mm"
                          ? false
                          : true
                      }
                      disabledHours={disabledHours}
                      disabledMinutes={disabledMinutes}
                      popupClassName="rc-time-picker-panel"
                      ref={timeInputRef} // Attach ref to TimePicker
                    />
                  ) : (
                    <TimePicker
                      value={handleTimeValue(value)}
                      onChange={handleOnChange}
                      showSecond={false}
                      allowEmpty={false}
                      use12Hours={
                        settings?.regionalSettings?.timeFormat === "hh:mm"
                          ? false
                          : true
                      }
                      popupClassName="rc-time-picker-panel"
                      ref={timeInputRef} // Attach ref to TimePicker
                    />
                  )}
                </div>
              )}
            </div>
          ) : (
            <input
              className={`${inputClass} Input ${
                errorMessage && "Input_errorInput"
              }`}
              disabled={isDisabled}
              required={isRequired}
              autocomplete={autocomplete}
              min={0}
              max={max}
              value={value}
              type={inputType}
              placeholder={
                !label && isRequired ? `${placeholder} *` : placeholder
              }
              onChange={handleOnChange}
              onBlur={handleBlur}
              onKeyDown={onKeyDown}
              ref={ref}
            />
          )}
          {!loading && icon && (
            <span className={`${InputIconProp} Input_IconWrap`}>{icon}</span>
          )}
        </div>
        {dir && (
          <div
            className={`${iconClass} ${
              label ? Style.iconContainerLabel : Style.iconContainer
            }`}
          >
            {icon && <>{getIcon()}</>}
          </div>
        )}
        {rightStaticText && (
          <div
            className={`${Style.rightStaticText} ${
              label ? Style.iconContainerLabel : Style.iconContainer
            }`}
          >
            {rightStaticText}
          </div>
        )}
        {errorMessage && displayErrorMessage && (
          <p className="Input_errorMessage">
            {errorMessage === "Unauthorized"
              ? "Invalid credentials"
              : errorMessage}
          </p>
        )}
      </div>
    </>
  );
});
export default CustomInput;
